export enum LoadState {
  NotLoaded = 0,
  InProgress = 1,
  Loaded = 2,
  Failed = 3,
}

export enum SaveState {
  NotStarted = 0,
  Progress = 1,
  Saved = 2,
}

export enum USER_ROLES {
  ADMIN = 1,
  CSR = 2,
  PRODUCER = 3,
  MARKETER = 4,
  BRANCH_MANAGER = 5,
}

export enum TEMPLATE_RELATED_MODULE_ID {
  LEAD = "LEAD",
}

export enum TASK_SUBTYPE {
  VEHICLE_CHANGE = "Vehicle Change",
  DRIVER_CHANGE = "Driver Change",
  COVERAGE_CHANGE = "Coverage Change",
  GARAGE_PLATE_CHANGE = "Garage Plate Change",
  INTERESTED_PARTY_CHANGE = "Interested Party Change",
  LESSOR_CHANGE = "Lessor Change",
  ADDRESS_CHANGE = "Address Change",
  RISK_LOCATION_CHANGE = "Risk Location Change",
  CANCELLATION_REINSTALLMENT = "Cancellation/Reinstatement",
  BUSINESS_SUBMISSION = "Business Submission",
  GENERAL_CHANGE = "General Change",
  PAYMENT_AUTH_CHANGE = "Payment Authorization Change",
  LAO_BOR = "LOA/BOR",
  LETTER_OF_EXPERIENCE = "Letter of Experience",

  NEW_BUSINESS = "Business",
  NEW_PERSONAL_AUTO = "Personal Auto",
  NEW_HOME = "Home",
  NEW_COMMERCIAL_AUTO = "Commercial Auto",
  NEW_PERSONAL_AND_HOME = "Personal Auto & Home",
  REMARKET_COMMERCIAL_AUTO = "Commercial Auto",
  REMARKET_HOME = "Home",
  REMARKET_BUSINESS = "Business",
  REMARKET_PERSONAL_AUTO = "Personal Auto",
  REMARKET_PERSONAL_AND_HOME = "Personal Auto & Home",
  QUOTE_REQUEST = "Quote Request",
  TASK_CERTIFICATE_OF_INSURANCE = "Certificate of Insurance",
}

export enum POLICIES {
  BUSINESS_POLICY = "Business Policy",
  AUTOMOBILE_POLICY = "Automobile Policy",
  HABITATIONAL_POLICY = "Habitational Policy",
  COMMERCIAL_AUTO_POLICY = "Commercial Auto Policy",
  LIFE_AND_FINCANCIAL_POLICY = "Life & Financial Policy",
}

export enum POLICIES_NAMES {
  BUSINESS_POLICY = "Business",
  AUTOMOBILE_POLICY = "Automobile",
  HABITATIONAL_POLICY = "Habitational",
  COMMERCIAL_AUTO_POLICY = "Commercial Auto",
  LIFE_AND_FINCANCIAL_POLICY = "Life & Financial",
}

export enum ERROR_MESSAGES {
  "NO_RECORD_FOUND" = "Unfortunately, there are no records available at the moment.",
  "SERVER_ERROR" = "Someting went to be wrong!",
  "POLICY_NOT_FOUND" = "Oops! We couldn't find any records at the moment. Please ensure that the provided information is accurate and try again.",
}

export enum MODULE_IDS {
  TASK = "latest_tasks",
  LEADS = "latest_leads",
  OPPORTUNITY = "latest_opportunity",
  CUSTOMER = "latest_customers_info",
  USER = "latest_user",
  ROLE = "change_role",
  SECURITY = "role_module",
  BRANCH = "latest_branch",
  ZONE = "zone",
}

export enum TRANSACTION_TYPE_ENUM {
  AuditPlus = "+ Audit",
  AuditMinus = "- Audit",
  Tax = "Tax",
  Reinstate = "Reinstate",
  Reissue = "Reissue",
  Rewrite = "Re-write",
  Correction = "Correction",
  Cancellation = "Cancellation",
  EndorsementPlus = "+ Endorsement",
  EndorsementMinus = "- Endorsement",
  Renewal = "Renewal",
  New = "New",
  FeeNSFFee = "Fee - NSF Fee",
  FeeServiceFee = "Fee - Service Fee",
  FeeInsuranceReports = "Fee - Insurance Reports",
  FeeFacilityFee = "Fee - Facility Fee",
  FeeMGAInsurerFee = "Fee - MGA/Insurer Fee",
  Payment = "Payment",
}

export enum MODULE_NAMES {
  LEADS = "Leads",
  OPPORTUNITY = "Opportunity",
  STUDENT = "Student",
  POLICIES = "Policies",
  LEGALS = "Legals",
  USER = "Users",
  ROLE = "Roles",
  SECURITY = "Security",
}

export enum ALLOWED_MODULES {
  SECURITY = "SECURITY|SECURITY|ROLE_MODULE",
  ROLE_GROUPS = "SECURITY|ROLE GROUPS|LATEST_ROLE_GROUPS",
  CHANGE_ROLE = "USERS|CHANGE ROLE|CHANGE_ROLE",
  ROLE_MODUKLE = "SECURITY|SECURITY|ROLE_MODULE",
  BRANCH = "DATA MANAGEMENT|BRANCH|LATEST_BRANCH",
  LEADS = "LEADS|LEADS|LATEST_LEADS",
  COMMENT = "COMMENT|COMMENT|LATEST_COMMENT_T",
  ZONE = "DATA MANAGEMENT|ZONE|ZONE",
  OPPORTUNITY = "OPPORTUNITY|OPPORTUNITY|LATEST_OPPORTUNITY",
  STUDENT = "STUDENT|STUDENT|LATEST_CUSTOMER_INFO",
  FEE_STRUCTURE = "MASTER|FEE STRUCTURE|LATEST_FEE_STRUCTURE",
  FEE_TRANSITION = "STUDENT|FEE TRANSACTION|LATEST_FEE_TRANSACTION",
  FEE_OVERRIDE = "MASTER|FEE OVERRIDE|LATEST_FEE_OVERRIDE",
  TEMPLATES = "TEMPLATES|TEMPLATES|LATEST_TEMPLATES",
  USERS = "USERS|USERS|LATEST_USER",
  ROLES = "USERS|CHANGE ROLE|CHANGE_ROLE",
  COURSE = "MASTER|COURSES|LATEST_COURSES",
  SESSION = "MASTER|SESSIONS|LATEST_SESSION_INFO",
  ORGANIZATION = "MASTER|ORGANIZATIONS|LATEST_ORGANIZATIONS",
}
